<div class="wrapper">

  <div class="ver-detalle" *ngIf="viewRejectReson">
    <div class="datos-detalle">
      <table class="tabla-detalle">
        <tr>
          <th>Firmante</th>
          <th>Mensaje</th>
        </tr>
        <tr *ngFor="let reject of msgRejectReason">
          <td>{{reject.signerName}}</td>
          <td>{{reject.reason}}</td>
        </tr>
      </table>
      <input type="button" class="boton volver2" value="Cancelar" (click)="cancel()">
    </div>
  </div>

  <div class="ver-detalle" *ngIf="viewDocumentInfo">
    <div class="datos-detalle">
      <table class="tabla-detalle">
        <tr>
          <th>Firmante</th>
          <th>Estado</th>
          <th>Fecha</th>
        </tr>
        <tr *ngFor="let signer of documentInformation.signers">
          <td>{{signer.name}}</td>
          <td class="{{signer.status.name}}">{{signer.status.nameEs}}</td>
          <td *ngIf="signer.operationTime!=='null'; else empty">{{signer.operationTime}}</td>
          <ng-template #empty>
            <td></td>
          </ng-template>
        </tr>
      </table>
      <input type="button" class="boton volver2" value="Volver" (click)="cancel()">
    </div>
  </div>

  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">DOCUMENTOS</h1>

    <div class="input-field col s12 buscador">
      <input id="filter" type="text" (keyup)="applyFilter($event.keyCode)" [(ngModel)]="textToSearch">
      <label for="filter" data-error="Ingrese un dato valido" data-success="">
        <button mat-icon-button (click)="search()">
          <mat-icon>search</mat-icon>
        </button>
      </label>
    </div>

    <app-spinner *ngIf="loading"></app-spinner>

    <div *ngIf="!loading">

      <div class="select-state" (change)="filterStatus($event)" *ngIf="!loading">

        <button mat-icon-button class="refrescar action-icon-btn" (click)="ngOnInit()" matTooltip="Actualizar"
          matTooltipPosition="above">
          <mat-icon>refresh</mat-icon>
        </button>
        <select>
          <option value="0" selected>Todos</option>
          <option value="1" class="pendiente">Pendiente</option>
          <option value="2" class="firmado">Firmado</option>
          <option value="3" class="rechazado">Rechazado</option>
          <option value="4" class="expirado">Expirado</option>
        </select>
      </div>

      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="tabla">
        <ng-container matColumnDef="expedient">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Expediente</th>
          <td mat-cell *matCellDef="let element">
            {{element.expedient}}
          </td>
        </ng-container>

        <ng-container matColumnDef="documentAddressee">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Destinatario </th>
          <td mat-cell *matCellDef="let element" class="{{element.documentType}}">
            {{element.documentAdresseeDTO.fullName}}
          </td>

        </ng-container>

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef> Firmante </th>
          <td mat-cell *matCellDef="let element">

            <p *ngFor="let signer of element.signers">{{signer.name}}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="template">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Documento </th>
          <td mat-cell *matCellDef="let element" class="{{element.status.nameEs}}"> {{element.templateName}} </td>
        </ng-container>

        <ng-container matColumnDef="creationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> F. Creación </th>
          <td mat-cell *matCellDef="let element"> {{element.creationDate | date:'dd-MM-yyyy HH:mm'}} </td>
        </ng-container>

        <ng-container matColumnDef="signatureDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> F. Firma </th>
          <td mat-cell *matCellDef="let element"> {{element.signatureDate | date:'dd-MM-yyyy HH:mm'}} </td>
        </ng-container>

        <ng-container matColumnDef="view">
          <th mat-header-cell *matHeaderCellDef>Acción</th>
          <td mat-cell *matCellDef="let element" class="action">

            <container-element [ngSwitch]="element.status.id">
              <button stop-propagation mat-icon-button class="action-icon-btn" *ngSwitchCase="2"
                (click)="downloadDocument(element.uuid);" matTooltip="Descargar" matTooltipPosition="above"
                aria-label="Descargar">
                <mat-icon class="first-icon">visibility</mat-icon>
              </button>

              <container-element *ngSwitchCase="3">
                <button stop-propagation mat-icon-button class="action-icon-btn"
                  *ngIf="element.rejectReason != null; else notRejectedReason"
                  (click)="viewRejectReason(element.rejectReason);" matTooltip="Detalle" matTooltipPosition="above"
                  aria-label="Detalle">
                  <mat-icon class="only-icon">visibility</mat-icon>
                </button>
                <ng-template #notRejectedReason>
                  <button stop-propagation (click)="downloadDocument(element.uuid);" mat-icon-button disabled
                    aria-label="Example icon button with a vertical three dot icon">
                    <mat-icon class="only-icon-disabled">visibility</mat-icon>
                  </button>
                </ng-template>
              </container-element>
              <button stop-propagation mat-icon-button class="action-icon-btn" *ngSwitchCase="1"
                (click)="documentInfo(element.uuid);" matTooltip="Detalle" matTooltipPosition="above"
                aria-label="Detalle">
                <mat-icon class="only-icon">visibility</mat-icon>
              </button>

              <button stop-propagation mat-icon-button class="action-icon-btn"
                *ngIf="(element.status.name === 'expired')" (click)="resignVidForms(element);" matTooltip="Reenviar"
                matTooltipPosition="above" aria-label="Reenviar">
                <mat-icon>autorenew</mat-icon>
              </button>

            </container-element>

            <button stop-propagation mat-icon-button class="action-icon-btn"
              *ngIf="(element.status.name === 'signed' && element.documentType === 'remote' )"
              (click)="downloadReport(element.uuid);" matTooltip="Evidencias" matTooltipPosition="above"
              aria-label="Evidencias">
              <mat-icon>find_in_page</mat-icon>
            </button>

            <button stop-propagation mat-icon-button class="action-icon-btn"
              *ngIf="(element.status.name === 'signed' && element.signers[0].vidForms.length > 0)"
              (click)="downloadVidForms(element.uuid);" matTooltip="Formularios" matTooltipPosition="above"
              aria-label="Formularios">
              <mat-icon>playlist_add_check</mat-icon>
            </button>

          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"
          (click)="navigateDocument(row.uuid)"></tr>
      </table>

      <mat-card appearance="outlined" *ngIf="loadingDataTable"
        style="display: flex; justify-content: center; align-items: center">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </mat-card>

      <div class="paginacion">
        <label>Items por página: </label>
        <select class="items" [(ngModel)]="pageable.pageSize" (change)="itemsByPage()">
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>

        <button mat-icon-button disabled={{pageable.first}} (click)="first()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button>
        <button mat-icon-button disabled={{pageable.first}} (click)="previus()">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <button mat-icon-button disabled={{pageable.last}} (click)="next()">
          <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button disabled={{pageable.last}} (click)="end()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>